import React, { lazy, Suspense } from 'react';
import { createBrowserRouter } from 'react-router-dom';
import MainLayout from '../Components/Layouts/main-layout.js';
import {
	dashboardColumnData,
	dashboardNavData
} from '../Assets/Constants/json_constants.js';
import UnProtectedLayout from '../Components/Layouts/un-protected-layout.js';
import Approval from '../Components/Pages/redirect.js';
import Inventory from '../Components/Pages/inventory.js';
import ErrorBoundary from '../Components/Pages/error-boundary.js';
import BulkInventory from '../Components/Pages/bulk-inventory.js';
import { routeConstants } from '../utils/path-constants.js';
import TabContentRenderer from '../Components/Pages/tab-content-renderer.js';
import { APIENDPOINTS } from '../Services/ApiEndPoints/api-endpoints.js';

const DashBoard = lazy(
	() => import('../Components/Pages/Dashboard/dashboard.js')
);
const UserAndBranchDashboard = lazy(
	() => import('../Components/Pages/UAMDashboard/user-and-branch-dashboard.js')
);
const Edit = lazy(() => import('../Components/Pages/Edit/edit.js'));
const Profile = lazy(() => import('../Components/Pages/Profile/profile.js'));
const EditProfilePage = lazy(() => import('../Components/Pages/Profile/edit-profile-page.js'));

const EditPersonalInfo = lazy(
	() => import('../Components/Pages/Profile/edit-personal-info.js')
);

const Template = lazy(() => import('../Components/Pages/Template/template.js'));
const ErrorPage = lazy(
	() => import('../Components/Pages/404ErrorPage/error-page.js')
);
const Login = lazy(() => import('../Components/Pages/Login/login.js'));
const ForgetPassword = lazy(
	() => import('../Components/Pages/Login/forget-password.js')
);
const ResetPassword = lazy(
	() => import('../Components/Pages/Login/reset-password.js')
);
const Settings = lazy(() => import('../Components/Pages/Settings/settings.js'));
const OverViewDashboard = lazy(
	() => import('../Components/Pages/StatisticOverview/over-view-dashboard.js')
);
const LandingPage = lazy(
	() => import('../Components/Pages/LandingPage/landing-page.js')
);
const WalletHistory = lazy(
	() => import('../Components/Pages/WalletHistory/wallet-history.js')
);
const Wallet = lazy(() => import('../Components/Pages/Wallet/wallet.js'));
const BulkESign = lazy(
	() => import('../Components/Pages/Bulk-eSign/bulk-e-sign.js')
);
const SignUp = lazy(
	() => import('../Components/Pages/IndividualUser/sign-up.js')
);
const NewEsign = lazy(
	() => import('../Components/Pages/NewEsign/new-esign.js')
);
const Signature = lazy(() => import('../Components/Pages/signature.js'));

export default createBrowserRouter([
	{
		element: (
			<ErrorBoundary>
				<MainLayout />
			</ErrorBoundary>
		),
		children: [
			{ path: routeConstants.inventory(), element: <Inventory /> },
			{
				path: routeConstants.bulkInventory(),
				element: <BulkInventory />
			},
			{ path: routeConstants.EDIT, element: <Edit /> },
			{ path: routeConstants.TEMPLATE, element: <Template /> },
			{ path: routeConstants.PROFILE, element: <Profile /> },
			{ path: routeConstants.PROFILE_EDIT, element: <EditProfilePage /> },
			{ path: routeConstants.PERSONAL_INFO, element: <EditPersonalInfo /> },
			{
				path: routeConstants.DASHBOARD,
				element: (
					<DashBoard columns={dashboardColumnData} navs={dashboardNavData} />
				)
			},
			{ path: routeConstants.WALLET, element: <Wallet /> },
			{ path: routeConstants.WALLET_HISTORY, element: <WalletHistory /> },
			{ path: routeConstants.UAM, element: <UserAndBranchDashboard /> },
			{ path: routeConstants.SIGNATURE, element: <Signature /> },
			{ path: routeConstants.SETTINGS, element: <Settings /> },
			{
				path: routeConstants.RESET_PASSWORD_PROFILE,
				element: <ResetPassword />
			},
			{
				path: routeConstants.STATISTICS,
				element: <OverViewDashboard />
			},
			{
				path: routeConstants.BULK_ESIGN,
				element: <BulkESign />
			},
			{
				path: routeConstants.NEW_ESIGN,
				element: <NewEsign />
			},
			{
				path: routeConstants.ACTION_REQUIRED,
				element: (
					<TabContentRenderer
						tabs={[
							{
								id: 1,
								value: 'Payment Pending',
								endpoint: APIENDPOINTS.ACTION_REQUIRED.paymentPending
							},
							{
								id: 2,
								value: 'Awaiting Signing',
								endpoint: APIENDPOINTS.ACTION_REQUIRED.awaitSigning
							}
						]}
						type='action-required'
					/>
				)
			},
			{
				path: routeConstants.WAITING_FOR_OTHERS,
				element: (
					<TabContentRenderer
						tabs={[
							{
								id: 1,
								value: 'Payment Pending',
								endpoint: APIENDPOINTS.WAITING_FOR_OTHERS.paymentPending
							},
							{
								id: 2,
								value: 'Awaiting Signing',
								endpoint: APIENDPOINTS.WAITING_FOR_OTHERS.awaitSigning
							}
						]}
						type='waititng-for-others'
					/>
				)
			},
			{
				path: routeConstants.SIGNED,
				element: (
					<TabContentRenderer
						tabs={[
							{
								id: 1,
								value: 'Signed',
								endpoint: APIENDPOINTS.SIGNED.signed
							}
						]}
						type='signed'

					/>
				)
			},
			{
				path: routeConstants.UNSUCCESSFUL_WORKFLOWS,
				element: (
					<TabContentRenderer
						tabs={[
							{
								id: 1,
								value: 'Payment Pending',
								endpoint: APIENDPOINTS.UNSUCCESSFUL_WORKFLOWS.paymentPending,
								keyName: 'paymentPending'
							},
							{
								id: 2,
								value: 'Customer Rejected',
								endpoint: APIENDPOINTS.UNSUCCESSFUL_WORKFLOWS.customerRejected
							},
							{
								id: 3,
								value: 'Signing Expired',
								endpoint: APIENDPOINTS.UNSUCCESSFUL_WORKFLOWS.signingExpired
							},
							{
								id: 4,
								value: 'Verification Failed',
								endpoint: APIENDPOINTS.UNSUCCESSFUL_WORKFLOWS.verificationFailed
							},
							{
								id: 5,
								value: 'Cancelled',
								endpoint: APIENDPOINTS.UNSUCCESSFUL_WORKFLOWS.cancelled
							}
						]}
						type='unsuccessful-workflows'
					/>
				)
			}
		]
	},
	{
		element: (
			<ErrorBoundary>
				<UnProtectedLayout />
			</ErrorBoundary>
		),
		children: [
			{ path: routeConstants.LANDING_PAGE, element: <LandingPage /> },
			{ path: routeConstants.RESET_PASSWORD, element: <ResetPassword /> },
			{ path: routeConstants.FORGET_PASSWORD, element: <ForgetPassword /> },
			{ path: routeConstants.LOGIN, element: <Login /> },
			{ path: routeConstants.SIGN_UP, element: <SignUp /> }
		]
	},
	{ path: 'approvals/:page/:id', element: <Approval /> },
	{
		path: '*',
		element: (
			<Suspense fallback={<></>}>
				<ErrorPage />
			</Suspense>
		)
	}
]);
